// src/components/Footer.jsx
export default function Footer() {
  const gymAddress =
    "First Floor, Opp. Manakwal Road, Satjot Nagar, Duggri, Ludhiana, Punjab 141013";
  const phoneNumber = "+91 98760 93934";
  const mapsLink =
    "https://www.google.com/maps/place/Krio+gym/@30.8548102,75.8383907,17z";

  return (
    <footer className="mt-16 border-t border-slate-800 bg-surface-dark">
      <div className="max-w-6xl mx-auto px-5 md:px-8 lg:px-10 py-14">

        {/* MAIN GRID */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">

          {/* LEFT : MAP */}
          <div className="md:col-span-1">
            <div className="w-full aspect-video rounded-xl overflow-hidden border border-slate-700 shadow-lg">
              <iframe
                src="https://www.google.com/maps?q=30.8548102,75.8383907&z=16&output=embed"
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="KrioGym Location"
              />
            </div>
          </div>

          {/* RIGHT : CONTENT */}
          <div className="md:col-span-2 flex flex-col items-end text-right space-y-6">

            {/* Gym Name + Logo */}
            <div className="flex items-center gap-2 justify-end">
               <img 
            src="/logo.png" // Replace with your actual logo path (public/logo.png)
            alt="KrioGym Logo" 
            className="w-20 h-10 object-contain " 
          />
              <h3 className="text-2xl font-extrabold text-white">
                KRIO <span className="text-primary">GYM</span>
              </h3>
            </div>

            {/* Address */}
            <a
              href={mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-300 hover:text-primary transition-colors text-base leading-relaxed max-w-md inline-block"
              aria-label="Gym Address - opens in Google Maps"
            >
              {gymAddress}
            </a>

            {/* Phone */}
            <a
              href={`tel:${phoneNumber}`}
              className="text-slate-400 hover:text-primary transition-colors text-base"
              aria-label={`Call ${phoneNumber}`}
            >
              {phoneNumber}
            </a>

            {/* Social Icons */}
            <div className="flex gap-6 pt-2">
              {/* Facebook */}
              <a
                href="https://www.facebook.com/" // Replace with real URL
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-primary transition-transform hover:scale-110"
                aria-label="Facebook"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                  <path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2v-2.9h2V9.8c0-2 1.2-3.1 3-3.1.9 0 1.8.1 1.8.1v2h-1c-1 0-1.3.6-1.3 1.2v1.5h2.3l-.4 2.9h-1.9v7A10 10 0 0 0 22 12z" />
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/" // Replace with real URL
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-primary transition-transform hover:scale-110"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                  <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 5.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2zm0 1.6a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
                </svg>
              </a>

              {/* YouTube */}
              <a
                href="https://www.youtube.com/" // Replace with real URL
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-primary transition-transform hover:scale-110"
                aria-label="YouTube"
              >
                <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current">
                  <path d="M23.5 6.2s-.2-1.7-.9-2.4c-.8-.9-1.7-.9-2.1-1C17.4 2.5 12 2.5 12 2.5s-5.4 0-8.5.3c-.4.1-1.3.1-2.1 1C.7 4.5.5 6.2.5 6.2S.3 8.1.3 10v2c0 1.9.2 3.8.2 3.8s.2 1.7.9 2.4c.8.9 1.9.8 2.4.9 1.7.2 7.2.3 7.2.3s5.4 0 8.5-.3c.4-.1 1.3-.1 2.1-1 .7-.7.9-2.4.9-2.4s.2-1.9.2-3.8v-2c0-1.9-.2-3.8-.2-3.8zM9.8 14.5V7.9l6.2 3.3-6.2 3.3z" />
                </svg>
              </a>
            </div>

            {/* Credit */}
            <p className="text-slate-600 text-sm pt-4 text-right">
              © 2025 KrioGym Ludhiana  
              <br />
              Website by{" "}
              <a
                href="https://www.codevistasolutions.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                Codevista Solutions Pvt Ltd.
              </a>
              </p>

          </div>
        </div>
      </div>
    </footer>
  );
}


// // src/components/Footer.jsx
// export default function Footer() {
//   const gymAddress =
//     "First Floor, Opp. Manakwal Road, Satjot Nagar, Duggri, Ludhiana, Punjab 141013";
//   const phoneNumber = "+91 9XXXXXXXXX";
//   const mapsLink =
//     "https://www.google.com/maps/place/Krio+gym/@30.8548102,75.8383907,17z";

//   return (
//     <footer className="mt-16 border-t border-slate-800 bg-surface-dark">
//       <div className="max-w-6xl mx-auto px-5 md:px-8 lg:px-10 py-14">

//         {/* MAIN GRID */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">

//           {/* LEFT : MAP (SMALL) */}
//           <div className="md:col-span-1">
//             <div className="w-full aspect-video rounded-xl overflow-hidden border border-slate-700 shadow-lg">
//               <iframe
//                 src="https://www.google.com/maps?q=30.8548102,75.8383907&z=16&output=embed"
//                 className="w-full h-full"
//                 loading="lazy"
//                 referrerPolicy="no-referrer-when-downgrade"
//                 title="KrioGym Location"
//               />
//             </div>
//           </div>

//           {/* RIGHT : ALL CONTENT */}
//           <div className="md:col-span-2 flex flex-col items-end text-right space-y-6">

//             {/* Gym Name + Logo Icon */}
//             <div className="flex items-center gap-3 justify-end">
//               <svg
//                 viewBox="0 0 24 24"
//                 className="w-8 h-8 fill-primary"
//               >
//                 <path d="M4 6h2v12H4V6zm14 0h2v12h-2V6zM7 10h2v4H7v-4zm8 0h2v4h-2v-4zM10 8h4v8h-4V8z" />
//               </svg>
//               <h3 className="text-2xl font-extrabold text-white">
//                 KRIO <span className="text-primary">GYM</span>
//               </h3>
//             </div>

//             {/* Address */}
//             <a
//               href={mapsLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-slate-300 hover:text-primary transition-colors text-base leading-relaxed max-w-md"
//             >
//               {gymAddress}
//             </a>

//             {/* Phone */}
//             <a
//               href={`tel:${phoneNumber}`}
//               className="text-slate-400 hover:text-primary transition-colors text-base"
//             >
//               {phoneNumber}
//             </a>

//             {/* Social Icons (RIGHT SIDE) */}
//             <div className="flex gap-6 pt-2">
//               {/* Facebook */}
//               <a className="text-slate-400 hover:text-primary transition-transform hover:scale-110">
//                 <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
//                   <path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2v-2.9h2V9.8c0-2 1.2-3.1 3-3.1.9 0 1.8.1 1.8.1v2h-1c-1 0-1.3.6-1.3 1.2v1.5h2.3l-.4 2.9h-1.9v7A10 10 0 0 0 22 12z" />
//                 </svg>
//               </a>

//               {/* Instagram */}
//               <a className="text-slate-400 hover:text-primary transition-transform hover:scale-110">
//                 <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
//                   <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 5.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2zm0 1.6a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
//                 </svg>
//               </a>

//               {/* YouTube */}
//               <a className="text-slate-400 hover:text-primary transition-transform hover:scale-110">
//                 <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current">
//                   <path d="M23.5 6.2s-.2-1.7-.9-2.4c-.8-.9-1.7-.9-2.1-1C17.4 2.5 12 2.5 12 2.5s-5.4 0-8.5.3c-.4.1-1.3.1-2.1 1C.7 4.5.5 6.2.5 6.2S.3 8.1.3 10v2c0 1.9.2 3.8.2 3.8s.2 1.7.9 2.4c.8.9 1.9.8 2.4.9 1.7.2 7.2.3 7.2.3s5.4 0 8.5-.3c.4-.1 1.3-.1 2.1-1 .7-.7.9-2.4.9-2.4s.2-1.9.2-3.8v-2c0-1.9-.2-3.8-.2-3.8zM9.8 14.5V7.9l6.2 3.3-6.2 3.3z" />
//                 </svg>
//               </a>
//             </div>

//             {/* Credit */}
//             {/* <p className="text-slate-600 text-sm pt-4">
//               © 2025 KrioGym Ludhiana  
//               <br />
//               Website generated by Codevista Solutions Pvt Ltd.
//             </p> */}
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }



// // // src/components/Footer.jsx
// // export default function Footer() {
// //   const gymAddress = "First Floor, Opp. Manakwal Road, Satjot Nagar, Duggri, Ludhiana, Punjab 141013";
// //   const mapsLink = "https://share.google/dlAzOlccvI4dzkYA6";

// //   return (
// //     <footer className="py-12 max-w-6xl mx-auto px-5 md:px-8 lg:px-10 border-t border-slate-800 mt-12 bg-surface-dark">
// //       {/* Social Links - Only Icons */}
// //       <div className="flex justify-center gap-10 md:gap-12 mb-10">
// //         <a 
// //           href="#" 
// //           target="_blank" 
// //           rel="noopener noreferrer"
// //           className="text-slate-400 hover:text-primary transition-all duration-300 transform hover:scale-110"
// //           aria-label="Facebook"
// //         >
// //           <span className="material-symbols-outlined text-4xl">facebook</span>
// //         </a>
// //         <a 
// //           href="#" 
// //           target="_blank" 
// //           rel="noopener noreferrer"
// //           className="text-slate-400 hover:text-primary transition-all duration-300 transform hover:scale-110"
// //           aria-label="Instagram"
// //         >
// //           <span className="material-symbols-outlined text-4xl">Instagram</span>
// //         </a>
// //         <a 
// //           href="#" 
// //           target="_blank" 
// //           rel="noopener noreferrer"
// //           className="text-slate-400 hover:text-primary transition-all duration-300 transform hover:scale-110"
// //           aria-label="YouTube"
// //         >
// //           <span className="material-symbols-outlined text-4xl">Youtube</span>
// //         </a>
// //       </div>

// //       {/* Map + Address - Side by Side on md+ */}
// //       <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-10">
// //         {/* Left: Google Maps Embed */}
// //         <div className="w-full aspect-video md:aspect-square rounded-xl overflow-hidden border border-slate-700 shadow-xl order-1 md:order-1">
// //           <iframe
// //             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.123456789012!2d75.843210!3d30.886543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzDCsDUzJzExLjYiTiA3NcKwNTAnMzUuNiJF!5e0!3m2!1sen!2sin!4v1738299999999" // ← Replace with REAL embed src
// //             width="100%"
// //             height="100%"
// //             style={{ border: 0 }}
// //             allowFullScreen=""
// //             loading="lazy"
// //             referrerPolicy="no-referrer-when-downgrade"
// //             title="KrioGym Location Map"
// //           ></iframe>
// //         </div>

// //         {/* Right: Address */}
// //         <div className="text-center md:text-left order-2 md:order-2">
// //           <h4 className="text-xl font-bold text-white mb-4 flex items-center justify-center md:justify-start gap-3">
// //             <span className="material-symbols-outlined text-primary text-3xl">Location</span>
// //           </h4>
// //           <a 
// //             href={mapsLink} 
// //             target="_blank" 
// //             rel="noopener noreferrer"
// //             className="inline-flex items-start gap-3 text-slate-300 hover:text-primary text-lg transition-colors"
// //           >
// //             <span className="leading-relaxed">{gymAddress}</span>
// //           </a>
// //         </div>
// //       </div>

// //       {/* Copyright & Credit */}
// //       <div className="text-center">
// //         <p className="text-slate-500 text-base mb-2">
// //           © 2025 KrioGym Ludhiana. All rights reserved.
// //         </p>
// //         <p className="text-slate-600 text-sm">
// //           Website generated by Codevista Solutions Pvt Ltd.
// //         </p>
// //       </div>
// //     </footer>
// //   );
// // }